export enum TrainingStatusEnum {
    None = 0,
    ScheduledTraining = 1,
    PassedTraining = 2,
    FailedTraining = 3,
    MissedTraining = 4
}
